import { handleApiError } from '@/handleApiError'
import api from '@/modules/punchout/api'
import { PunchoutForm } from '@/types/index'
import { defineStore } from 'pinia'

interface PunchoutState {
  punchoutFormData: PunchoutForm
  loading: boolean
}

const initialState = (): PunchoutState => {
  return {
    punchoutFormData: {
      payload: '',
      eprocurementUrl: '',
      target: '',
      items: []
    },
    loading: false
  }
}

const usePunchout = defineStore('punchout', {
  state: () => initialState(),
  actions: {
    async loadPunchoutCartForm(supplierCartId?: string) {
      this.loading = true
      return api
        .loadPunchoutCartForm(supplierCartId)
        .then(({ data }) => {
          this.punchoutFormData = data
        })
        .catch(handleApiError)
        .finally(() => {
          this.loading = false
        })
    },
    async loadPunchoutQuoteForm(quoteId: string) {
      this.loading = true
      return api
        .loadPunchoutQuoteForm(quoteId)
        .then(({ data }) => {
          this.punchoutFormData = data
        })
        .catch(handleApiError)
        .finally(() => {
          this.loading = false
        })
    }
  }
})

export default usePunchout
